.gridContainer {
  display: grid;
  grid-template-columns: repeat(8, 3.2px);
  grid-template-rows: repeat(8, 3.2px);
  gap: 0;
  padding: 1.6px;
  border-radius: 0.8px;
  place-items: center;
  position: relative;
  mask: radial-gradient(
    circle 2.8px at center,
    transparent 2.8px,
    black 2.9px
  );
  -webkit-mask: radial-gradient(
    circle 2.8px at center,
    transparent 2.8px,
    black 2.9px
  );
  width: fit-content;
  height: fit-content;
}

.backgroundSquare {
  position: absolute;
  width: 9.6px;
  height: 9.6px;
  background-color: black;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  display: none;
}

.circle {
  border-radius: 50%;
  position: relative;
  z-index: 2;
  animation: scaleInOut 2s ease-in-out infinite;
}

@keyframes scaleInOut {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(0);
  }
}

.size1 {
  width: 0.3px;
  height: 0.3px;
}
.size2 {
  width: 0.6px;
  height: 0.6px;
}
.size3 {
  width: 1.3px;
  height: 1.3px;
}
.size4 {
  width: 1.9px;
  height: 1.9px;
}
.size5 {
  width: 2.6px;
  height: 2.6px;
}
.size8 {
  width: 3.5px;
  height: 3.5px;
}
.size9 {
  width: 5.9px;
  height: 5.9px;
}

.gridContainer > :nth-child(2) {
  animation-delay: 0s;
}
.gridContainer > :nth-child(3) {
  animation-delay: 0s;
}
.gridContainer > :nth-child(4) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(5) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(6) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(7) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(8) {
  animation-delay: 0s;
}
.gridContainer > :nth-child(9) {
  animation-delay: 0s;
}
.gridContainer > :nth-child(10) {
  animation-delay: 0s;
}
.gridContainer > :nth-child(11) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(12) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(13) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(14) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(15) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(16) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(17) {
  animation-delay: 0s;
}
.gridContainer > :nth-child(18) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(19) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(20) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(21) {
  animation-delay: 0.4s;
}
.gridContainer > :nth-child(22) {
  animation-delay: 0.4s;
}
.gridContainer > :nth-child(23) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(24) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(25) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(26) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(27) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(28) {
  animation-delay: 0.4s;
}
.gridContainer > :nth-child(29) {
  animation-delay: 0.5s;
}
.gridContainer > :nth-child(30) {
  animation-delay: 0.5s;
}
.gridContainer > :nth-child(31) {
  animation-delay: 0.4s;
}
.gridContainer > :nth-child(32) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(33) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(34) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(35) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(36) {
  animation-delay: 0.4s;
}
.gridContainer > :nth-child(37) {
  animation-delay: 0.5s;
}
.gridContainer > :nth-child(38) {
  animation-delay: 0.5s;
}
.gridContainer > :nth-child(39) {
  animation-delay: 0.4s;
}
.gridContainer > :nth-child(40) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(41) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(42) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(43) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(44) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(45) {
  animation-delay: 0.4s;
}
.gridContainer > :nth-child(46) {
  animation-delay: 0.4s;
}
.gridContainer > :nth-child(47) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(48) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(49) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(50) {
  animation-delay: 0s;
}
.gridContainer > :nth-child(51) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(52) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(53) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(54) {
  animation-delay: 0.3s;
}
.gridContainer > :nth-child(55) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(56) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(57) {
  animation-delay: 0s;
}
.gridContainer > :nth-child(58) {
  animation-delay: 0s;
}
.gridContainer > :nth-child(59) {
  animation-delay: 0s;
}
.gridContainer > :nth-child(60) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(61) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(62) {
  animation-delay: 0.2s;
}
.gridContainer > :nth-child(63) {
  animation-delay: 0.1s;
}
.gridContainer > :nth-child(64) {
  animation-delay: 0s;
}
.gridContainer > :nth-child(65) {
  animation-delay: 0s;
}



